import React from 'react'
import { Drawer, Pagination, Spin, Timeline } from 'antd'
import { map, noop } from 'lodash'
import PropTypes from 'prop-types'

import { PAGINATION } from '../../constants'
import { renderTreeSaveEvent } from '../../helpers'
import { eventPropType, idPropType, optionPropType } from '../../prop-types'
import { StyledVerticalSpace } from '../styled'

import HistoryDrawerFilter from './history-drawer-filter'

const HistoryDrawer = ({
  loading,
  events,
  onClose,
  userOptions,
  page,
  pageSize,
  total,
  createdByIds,
  startAt,
  endAt,
  types,
  subtypes,
  searchTerm,
  exactSearchTerm,
  onFilter,
  onChangePagination,
  renderEvent,
  filterEventTypes,
  eventMetadataTypes,
}) => (
  <Drawer
    title="History Drawer"
    placement="right"
    width={800}
    onClose={onClose}
    visible
  >
    {loading ? (
      <Spin />
    ) : (
      <StyledVerticalSpace>
        <HistoryDrawerFilter
          userOptions={userOptions}
          types={types}
          subtypes={subtypes}
          createdByIds={createdByIds}
          startAt={startAt}
          endAt={endAt}
          onFilter={onFilter}
          filterEventTypes={filterEventTypes}
          eventMetadataTypes={eventMetadataTypes}
          searchTerm={searchTerm}
          exactSearchTerm={exactSearchTerm}
        />
        <Timeline>{map(events, event => renderEvent(event))}</Timeline>

        <Pagination
          showSizeChanger
          onChange={onChangePagination}
          onShowSizeChange={onChangePagination}
          current={page}
          total={total}
          pageSize={pageSize}
          pageSizeOptions={PAGINATION.DEFAULT_PAGINATION_SIZE_OPTIONS}
        />
      </StyledVerticalSpace>
    )}
  </Drawer>
)

HistoryDrawer.propTypes = {
  events: PropTypes.arrayOf(eventPropType),
  onClose: PropTypes.func,
  userOptions: PropTypes.arrayOf(optionPropType),
  createdByIds: PropTypes.arrayOf(idPropType),
  startAt: PropTypes.string,
  endAt: PropTypes.string,
  onFilter: PropTypes.func,
  onChangePagination: PropTypes.func.isRequired,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  loading: PropTypes.bool,
  renderEvent: PropTypes.func,
  filterEventTypes: PropTypes.bool,
  types: PropTypes.arrayOf(PropTypes.string),
  subtypes: PropTypes.arrayOf(PropTypes.string),
  searchTerm: PropTypes.string,
  exactSearchTerm: PropTypes.string,
  eventMetadataTypes: PropTypes.arrayOf(PropTypes.string),
}

HistoryDrawer.defaultProps = {
  loading: false,
  events: [],
  onClose: noop,
  userOptions: [],
  createdByIds: [],
  startAt: undefined,
  endAt: undefined,
  types: [],
  subtypes: [],
  searchTerm: undefined,
  exactSearchTerm: undefined,
  onFilter: noop,
  page: PAGINATION.DEFAULT_PAGE,
  pageSize: PAGINATION.DEFAULT_PAGE_SIZE,
  total: 0,
  renderEvent: renderTreeSaveEvent,
  filterEventTypes: false,
  eventMetadataTypes: [],
}

export default HistoryDrawer
